import { KnowledgeItemPreviewItemModel } from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement, useMemo } from "react";
import { HubItemStatistic, ListItemProps } from "../common";
import { ListItemBase } from "./ListItemBase";
import { useHubStatisticsFormatter } from "client/Features/Hub/useHubStatisticsFormatter";
import { NumberFormatter } from "client/Hooks";
import { EMPTY_ARRAY, isNotNil } from "client/Misc/utils";

export type KnowledgeItemListItemProps = ListItemProps<KnowledgeItemPreviewItemModel>;

export const KnowledgeItemListItem = (props: KnowledgeItemListItemProps): ReactElement => {
	const {
		item,
		isWideTile,
		isUltraWideTile,
		onOpen,
		timezone
	} = props;

	const statisticsFormatter: NumberFormatter = useHubStatisticsFormatter();

	const statistics = useMemo(
		(): readonly HubItemStatistic[] => {
			return [{
				icon: "eye",
				text: statisticsFormatter(item.viewsCount),
				trackingId: "view-count"
			}];
		},
		[item.viewsCount, statisticsFormatter]
	);

	const categoryNames = useMemo(
		(): readonly string[] => {
			return isNotNil(item.category)
				? [
					item.category
						.name
				]
				: EMPTY_ARRAY;
		},
		[item.category]
	);

	return (
		<ListItemBase
			itemKind={HubItemKind.KnowledgeItem}
			id={item.id}
			title={item.title}
			media={item.media}
			startDate={item.publicationDate}
			statistics={statistics}
			categoryNames={categoryNames}
			descriptionPreview={item.descriptionPreview}
			isWideTile={isWideTile}
			trackingIdBase="knowledge-item"
			onOpen={onOpen}
			authorName={item.author?.name ?? null}
			isUltraWideTile={isUltraWideTile}
			timezone={timezone}
			isPinned={isNotNil(item.pinDate)}
			isNew={item.isNew}
		/>
	);
};
KnowledgeItemListItem.displayName = "KnowledgeItemListItem";
